import { render, staticRenderFns } from "./AssessmentSelectHouse.vue?vue&type=template&id=0047106d&scoped=true&"
import script from "./AssessmentSelectHouse.vue?vue&type=script&lang=js&"
export * from "./AssessmentSelectHouse.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentSelectHouse.vue?vue&type=style&index=0&id=0047106d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047106d",
  null
  
)

export default component.exports